import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountrySearchPipe } from './country-search.pipe';

@NgModule({
  declarations: [CountrySearchPipe],
  imports: [CommonModule],
  exports: [CountrySearchPipe],
})
export class PipeModule {}